// extracted by mini-css-extract-plugin
export default {"main-div":"FeedsDescription_main-div__Pjtap"};